import { render } from "./WorldImages.vue?vue&type=template&id=2f6aa9bc&scoped=true"
import script from "./WorldImages.vue?vue&type=script&lang=js"
export * from "./WorldImages.vue?vue&type=script&lang=js"

import "./WorldImages.vue?vue&type=style&index=0&id=2f6aa9bc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Liam\\Documents\\werowebsite\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f6aa9bc"]])

export default __exports__